import React, { useEffect, useRef, useState } from 'react'
import Button from '../Button/Button';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../reducers/store';
import toast from 'react-hot-toast';
import { actionVerifyAdminRegEmail } from '../../actions/admins';
import { CheckCircleOutlineRounded } from '@mui/icons-material';
import {Loader} from '../';

import './verifyOtp.css'

interface VerifyOtpProps {
  id?: string;
  emailAddress?: string;
}

const VerifyOtp = ({id, emailAddress}: VerifyOtpProps) => {
    const dispatch                              = useDispatch<AppDispatch>();
    const [otp, setOtp]                         = useState("");
    const inputRefs                             = useRef<Array<HTMLInputElement | null>>([]);
    const [verifiedDisplay, setVerifiedDisplay] = useState(false)
    const [isVerifying, setIsVerifying]         = useState(false);
    const [timeLeft, setTimeLeft]               = useState(600);

    // Format time into mm:ss
    const formatTime = (secs: number) => {
        const m = Math.floor(secs / 60).toString().padStart(2, "0");
        const s = (secs % 60).toString().padStart(2, "0");
        return `${m}:${s}`;
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer); // Cleanup
    }, []);

    useEffect(() => { //reload page after timeLeft is complete
        if (timeLeft === 0) {
            window.location.reload();
        }
    }, [timeLeft]);

    const handleChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (isNaN(Number(value))) return;

        setOtp((prevOtp) => {
            const otpArr = prevOtp.split("");
            otpArr[index] = value;
            return otpArr.join("");
        });

        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handlePaste = async(event: React.ClipboardEvent<HTMLInputElement>) => {
        const pasteData = event.clipboardData.getData("text/plain");
        if (/^\d+$/.test(pasteData)) {
        const otpArray = pasteData.slice(0, 6).split("");
        const joinedOtp = otpArray.join("");

        setOtp(joinedOtp);

        otpArray.forEach((digit, idx) => {
            if (inputRefs.current[idx]) {
            inputRefs.current[idx]!.value = digit;
            }
        });

        if (otpArray.length === inputRefs.current.length) {
            inputRefs.current[inputRefs.current.length - 1]?.blur();
        } else {
            inputRefs.current[otpArray.length]?.focus();
        }
        event.preventDefault();

        setIsVerifying(true); //start loading

        const res = await dispatch(actionVerifyAdminRegEmail({ id, emailAddress, otp: joinedOtp }));
        // console.log(res)

        setIsVerifying(false); // Stop loading

        if (res?.success === true) {
            toast.success("OTP verified!");
            setVerifiedDisplay(true)
        } else {
            toast.error(res?.errorMessage || "Invalid OTP");
            setVerifiedDisplay(false)
        }

        }
    };

    const handleKeyDown = (index: number, event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

  return (
    <>
        {isVerifying ? (
            <>
                <Loader />
                <h1>Verifying your email...</h1>
            </>
            
        ) : !verifiedDisplay ? (
            <div className='verify-account-main-wrapper'>
                <div className='verify-account-main'>
                    <div className='email-section'>
                        <div className='email-details'>
                            Your Email Address is
                            <span>{emailAddress}</span>
                        </div>

                        <a href='/register' className='change-link'>
                            Change Email
                        </a>
                    </div>
                    <div className='main-verify-section'>
                        <div className='number-section'>
                            <span className='section-text-header'>we sent a digit code to your email</span>
                            
                            <div className='verify-input-group'>
                                {Array.from({ length: 6 }, (_, index) => (
                                    <input
                                        key={index}
                                        type="tel"
                                        maxLength={1}
                                        value={otp[index] || ""}
                                        onChange={(e) => handleChange(index, e)}
                                        onPaste={handlePaste}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                        ref={(ref) => {inputRefs.current[index] = ref}}
                                    />
                                ))}
                            </div>
                            <div className="resend-time">
                                <span>Resend</span>
                                <span>{formatTime(timeLeft)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div className='verify-wrapper'>
                <div className='verify-form-container'>
                <div className='verify-detail'>
                    <div className="verify-svg-wrapper verified"><CheckCircleOutlineRounded /></div>
                    <h3>Verified status</h3>
                    <span>Your account is successfully verified</span>
                </div>
                <Button linkButton linkTo="/login" linkClass="link-wrapper" linkName="Login" />
                </div>
            </div>
        )}
    </>
  )
}

export default VerifyOtp